<template>
  <v-app>
    <v-navigation-drawer app clipped v-if="isSignedin">
      <v-list-item :to="{ name: 'dashboard' }">
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{ $t('menu.home') }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ $t('menu.homeSubtitle') }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'api' }" v-if="showDeveloperAPI">
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.legacy')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.legacySubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'apiData' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                class="blink-animation"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>{{ $t('menu.deprecatedTooltip') }}</span>
          </v-tooltip>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{ $t('menu.data') }}
          </v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.integrationSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'apiDataImport' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                class="blink-animation"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>{{ $t('menu.deprecatedTooltip') }}</span>
          </v-tooltip>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{ $t('menu.import') }}
          </v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.integrationSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'engagement' }" v-if="showDeveloperAPI">
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.engagement')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.engagementSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'engagement-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.engagement')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.engagementService')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.engagementSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'performance' }" v-if="showDeveloperAPI">
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.performance')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.performanceSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'performance-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.performance')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{ $t('menu.performanceService') }}
          </v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.performanceSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'growth' }" v-if="showDeveloperAPI">
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{ $t('menu.growth') }}
          </v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.growthSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'growth-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.growth')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{ $t('menu.growthService') }}
          </v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.growthSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'customSurveys' }" v-if="showDeveloperAPI">
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.customSurveys')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.customSurveysSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'custom-surveys-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.customSurvey')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.customSurveysService')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.customSurveysSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'notification' }" v-if="showDeveloperAPI">
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.notification')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.notificationSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'management' }" v-if="showDeveloperAPI">
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.management')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.managementSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'management-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.management')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{
            $t('menu.managementService')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t('menu.managementSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark fixed clipped-left v-if="isSignedin">
      <div class="d-flex align-center">
        <h2>TeamCulture Developer Portal</h2>
      </div>

      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="mr-2">
            <span class="mr-1">{{ currentFlag }}</span> {{ currentLangName }}
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="lang in langs"
            :key="lang.code"
            @click="changeLocale(lang.code)"
          >
            <v-list-item-title
              >{{ lang.flag }} {{ lang.name }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn text @click="logout">
        <span class="mr-2">{{ $t('menu.logout') }}</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="page">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { projectAuth } from '@/firebase/config'

export default {
  name: 'App',
  components: {},

  data: () => ({
    isSignedin: true,
    showDeveloperAPI: false,
    langs: [
      { code: 'pt-br', name: 'Português', flag: '🇧🇷' },
      { code: 'en-us', name: 'English', flag: '🇺🇸' },
      { code: 'es-ar', name: 'Español', flag: '🇦🇷' },
    ],
  }),

  created() {
    this.isSignedin = false
    const $store = this.$store
    // console.log('[App.user]', user)
    projectAuth.onAuthStateChanged(async (user) => {
      if (user) {
        this.isSignedin = true
        // User is signed in.
        $store.dispatch('currentUser/loadCurrentUser', user)
      } else {
        this.isSignedin = false
        // User is signed out.
        $store.dispatch('currentUser/loadCurrentUser', {})
      }
    })
  },

  methods: {
    async logout() {
      projectAuth.signOut().then(() => {
        this.$router.push('/logout')
      })
    },
    changeLocale(locale) {
      this.$i18n.locale = locale
    },
  },
  computed: {
    currentFlag() {
      const current = this.langs.find((l) => l.code === this.$i18n.locale)
      return current ? current.flag : '🌐'
    },
    currentLangName() {
      const current = this.langs.find((l) => l.code === this.$i18n.locale)
      return current ? current.name : ''
    },
  },
  mounted() {},
}
</script>

<style lang="scss">
@import '@/global.scss';

.blink-animation {
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}

.bullet-deprecated {
  color: #dd0041;
  font-size: 24px;
  line-height: 1;
}

.page {
  background-color: $bg-1 !important;
  padding: 10px 35px !important;

  &.modal {
    height: calc(100vh - 24px);
    overflow: hidden;
  }
}
</style>
